import { Select as AntdSelect, SelectProps } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 4px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
  background: #ffffff;
  border-radius: 4px 4px 0 0;

  // modify style of Antd Icon
  & .anticon {
    font-size: 12px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: start;
  }
`;

export const HeaderTitleName = styled.span`
  color: rgba(0, 0, 0, 0.88);
  letter-spacing: -0.02em;
  font-weight: 500;
  font-size: 18px;
`;

export const TitleSelect = styled(AntdSelect)<SelectProps>`
  &&.emp-ant-select {
    .emp-ant-select-selector {
      color: #0046ff;
      padding: 0;
      height: 28px;
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 16px;
      letter-spacing: -0.02em;

      .emp-ant-select-selection-item {
        padding-right: 36px;
      }
    }

    .emp-ant-select-arrow {
      color: #0046ff;
    }
  }

  &.emp-ant-select-disabled .emp-ant-select-arrow {
    color: rgba(0, 0, 0, 0.25);
  }
`;

export const TransformRulesWrapper = styled.div`
  display: flex;
  gap: 16px;
  background: #fff;
  padding: 0 16px 16px;
  border-radius: 0 0 4px 4px;
`;
